import { useState, useEffect } from "react";

const ReportsPage = () => {
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [branches, setBranches] = useState([]);
  const [batches, setBatches] = useState([]);
  const [reportData, setReportData] = useState(null); // To store generated report data

  // Mock API calls for branches and batches
  useEffect(() => {
    const fetchBranches = async () => {
      setBranches([
        { id: "b1", name: "Main Studio - Downtown" },
        { id: "b2", name: "Satellite Studio - Uptown" },
      ]);
    };
    fetchBranches();
  }, []);

  useEffect(() => {
    const fetchBatches = async (branchId) => {
      if (!branchId) {
        setBatches([]);
        return;
      }
      if (branchId === "b1") {
        setBatches([
          { id: "batch101", name: "Hatha Yoga - Morning (B1)" },
          { id: "batch102", name: "Vinyasa Flow - Evening (B1)" },
        ]);
      } else if (branchId === "b2") {
        setBatches([
          { id: "batch201", name: "Restorative Yoga - Afternoon (B2)" },
          { id: "batch202", name: "Ashtanga - Early Morning (B2)" },
        ]);
      } else {
        setBatches([]);
      }
    };
    fetchBatches(selectedBranch);
  }, [selectedBranch]);

  const generateReport = async () => {
    if (!selectedBranch || !selectedBatch || !startDate || !endDate) {
      alert(
        "Please select a Branch, Batch, Start Date, and End Date to generate the report."
      );
      return;
    }

    console.log("Generating report for:", {
      selectedBranch,
      selectedBatch,
      startDate,
      endDate,
    });

    // Mock report data based on filters
    const mockReport = {
      reportType: "Attendance Summary",
      filters: {
        branch: selectedBranch,
        batch: selectedBatch,
        dateRange: `${startDate} to ${endDate}`,
      },
      summary: {
        totalClasses: 10,
        totalMembers: 30,
        averageAttendancePercentage: "85%",
      },
      details: [
        { date: "2025-07-20", className: "Hatha Yoga", present: 25, absent: 5 },
        { date: "2025-07-21", className: "Hatha Yoga", present: 28, absent: 2 },
        {
          date: "2025-07-22",
          className: "Hatha Yoga",
          present: 20,
          absent: 10,
        },
      ],
    };
    setReportData(mockReport);

    // In a real app, you'd make a fetch call:
    /*
    try {
      const response = await fetch(`http://localhost:8000/api/v1/reports/attendance-summary?branch_id=${selectedBranch}&batch_id=${selectedBatch}&start_date=${startDate}&end_date=${endDate}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
      });
      if (response.ok) {
        const data = await response.json();
        setReportData(data);
      } else {
        console.error('Failed to generate report:', await response.json());
        alert('Failed to generate report. Please check console for details.');
      }
    } catch (error) {
      console.error('Network error generating report:', error);
      alert('Network error generating report.');
    }
    */
  };

  return (
    <div className="p-8 bg-white rounded-lg shadow-xl">
      <h2 className="text-3xl font-bold text-gray-800 mb-6">Reports</h2>

      <div className="mb-8 p-6 bg-gray-50 rounded-lg shadow-md border border-gray-200">
        <h3 className="text-2xl font-semibold text-gray-700 mb-4">
          Report Filters
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label
              htmlFor="reportBranchSelect"
              className="block text-gray-700 text-sm font-semibold mb-2"
            >
              Branch:
            </label>
            <select
              id="reportBranchSelect"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={selectedBranch}
              onChange={(e) => {
                setSelectedBranch(e.target.value);
                setSelectedBatch("");
              }}
            >
              <option value="">-- Select Branch --</option>
              {branches.map((branch) => (
                <option key={branch.id} value={branch.id}>
                  {branch.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label
              htmlFor="reportBatchSelect"
              className="block text-gray-700 text-sm font-semibold mb-2"
            >
              Batch:
            </label>
            <select
              id="reportBatchSelect"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={selectedBatch}
              onChange={(e) => setSelectedBatch(e.target.value)}
              disabled={!selectedBranch}
            >
              <option value="">-- Select Batch --</option>
              {batches.map((batch) => (
                <option key={batch.id} value={batch.id}>
                  {batch.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label
              htmlFor="startDate"
              className="block text-gray-700 text-sm font-semibold mb-2"
            >
              Start Date:
            </label>
            <input
              type="date"
              id="startDate"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div>
            <label
              htmlFor="endDate"
              className="block text-gray-700 text-sm font-semibold mb-2"
            >
              End Date:
            </label>
            <input
              type="date"
              id="endDate"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>
        <div className="mt-6 text-right">
          <button
            onClick={generateReport}
            className="bg-blue-600 text-white py-2 px-6 rounded-md hover:bg-blue-700 transition-colors duration-300 font-semibold shadow-md"
          >
            Generate Report
          </button>
        </div>
      </div>

      {reportData && (
        <div className="mt-8 p-6 bg-white rounded-lg shadow-xl border border-gray-200">
          <h3 className="text-2xl font-bold text-gray-800 mb-4">
            {reportData.reportType}
          </h3>
          <div className="mb-4 text-gray-700">
            <p>
              <strong>Branch:</strong> {reportData.filters.branch}
            </p>
            <p>
              <strong>Batch:</strong> {reportData.filters.batch}
            </p>
            <p>
              <strong>Date Range:</strong> {reportData.filters.dateRange}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div className="bg-purple-50 p-4 rounded-lg shadow-sm">
              <p className="text-sm text-purple-700">Total Classes</p>
              <p className="text-2xl font-bold text-purple-900">
                {reportData.summary.totalClasses}
              </p>
            </div>
            <div className="bg-indigo-50 p-4 rounded-lg shadow-sm">
              <p className="text-sm text-indigo-700">Total Members</p>
              <p className="text-2xl font-bold text-indigo-900">
                {reportData.summary.totalMembers}
              </p>
            </div>
            <div className="bg-green-50 p-4 rounded-lg shadow-sm">
              <p className="text-sm text-green-700">Avg. Attendance %</p>
              <p className="text-2xl font-bold text-green-900">
                {reportData.summary.averageAttendancePercentage}
              </p>
            </div>
          </div>
          <h4 className="text-xl font-semibold text-gray-800 mb-3">
            Daily Attendance Details
          </h4>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">
                    Date
                  </th>
                  <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">
                    Class Name
                  </th>
                  <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">
                    Present
                  </th>
                  <th className="py-2 px-4 text-left text-xs font-medium text-gray-600 uppercase">
                    Absent
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {reportData.details.map((detail, index) => (
                  <tr key={index}>
                    <td className="py-2 px-4 whitespace-nowrap">
                      {detail.date}
                    </td>
                    <td className="py-2 px-4 whitespace-nowrap">
                      {detail.className}
                    </td>
                    <td className="py-2 px-4 whitespace-nowrap">
                      {detail.present}
                    </td>
                    <td className="py-2 px-4 whitespace-nowrap">
                      {detail.absent}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportsPage;
